import { render, staticRenderFns } from "./RemainingBalancePartnersCheck.vue?vue&type=template&id=5b8babbe&scoped=true&"
import script from "./RemainingBalancePartnersCheck.vue?vue&type=script&lang=js&"
export * from "./RemainingBalancePartnersCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8babbe",
  null
  
)

export default component.exports